import { PortletStoreApi } from './App';

export function initializeImprintLink(): void {
  initPopup();

  addOnClickFunction('login-imprint');
  addOnClickFunction('user-panel-imprint');
  addOnClickFunction('mobile-imprint');

  const popupContainer = window.document.getElementById(
    'imprint-dialog-container'
  );
  if (popupContainer) {
    popupContainer.onclick = function () {
      popupContainer.classList.remove('shown');
      popupContainer.classList.add('hidden');
    };
  }
}

function initPopup() {
  const popup = window.document.getElementById(
    'imprint-dialog-container-inner'
  );
  if (popup) {
    popup.innerHTML =
      '<iframe style="border:0;" src="' +
      PortletStoreApi.getState().url +
      '&operation=getImprint" width="100%" height="100%"></iframe>';
  }
}

function openPopup() {
  const popupContainer = window.document.getElementById(
    'imprint-dialog-container'
  );
  if (popupContainer) {
    popupContainer.classList.remove('hidden');
    popupContainer.classList.add('shown');
  }
}

function addOnClickFunction(divId: string) {
  const div = window.document.getElementById(divId);
  if (div) {
    div.onclick = openPopup;
    div.onkeydown = event => {
      if (event.key === 'Enter') {
        openPopup();
      }
    };
  }
}
